(function ($) {
  Drupal.behaviors.aaaPartialIncV1 = {
    attach: function (context, settings) {
    // alert( $('.aaa-partial-inc-v1').length );
    }
  };
})(jQuery);
